import React, { memo } from "react";

// Components
import { CSSTransition, TransitionGroup } from "react-transition-group";
import StealDealItem from "./StealDealItem";

// Types
import { StealDealItemListProps } from "../types";
import { CartItemWithUUID } from "@swiggy-private/cart-types";

// Styles
import styles from "./styles.scss";

const StealDealItemList = ({
    stealDealItems,
    isUnlockedState,
    onAddStealDeal,
    onAddStealDealEvent,
    isSnaccStorefrontV2,
}: StealDealItemListProps) => {
    return (
        <TransitionGroup className={styles.transition}>
            {stealDealItems?.map((item: CartItemWithUUID) => {
                return (
                    <CSSTransition
                        key={item.menu_item_id}
                        timeout={300}
                        classNames={{
                            enter: styles.itemEnter,
                            enterActive: styles.itemEnterActive,
                            exit: styles.itemExit,
                            exitActive: styles.itemExitActive,
                        }}
                    >
                        <StealDealItem
                            item={item}
                            isUnlockedState={isUnlockedState}
                            onAddStealDeal={onAddStealDeal}
                            onAddStealDealEvent={onAddStealDealEvent}
                            isSnaccStorefrontV2={isSnaccStorefrontV2}
                        />
                    </CSSTransition>
                );
            })}
        </TransitionGroup>
    );
};

export default memo(StealDealItemList);
